import getLatitudeBenefits from 'core/controllerPlans/renderDetails/getLatitudeBenefits'
import { numberToCurrency } from '@hc-frontend/utils'
import detailsDentalFees from 'core/controllerPlans/detailsDentalFees'
import getBadgeDental from 'core/controllerPlans/getBadgeDental'
import getURLProfile from 'utils/pivot/member/getURLProfile'
import isEpicPlan from 'utils/pivot/plan/isEpicPlan'
import isRXPlan from 'utils/pivot/plan/isRXPlan'
import store from 'utils/store/withMiddleware'
import moneyFormat from 'utils/format/money'
import { BTM } from 'core/constants/products'
import makeBase from '../makeBase'

const asMoneyWithoutDecimal = numberToCurrency

function makePayload({
  placement,
  valuesForm,
  agentInformation,
  latitudeJson,
  path,
  salesCenterAgent
}) {
  const data = makeBase({ valuesForm, agentInformation, salesCenterAgent })
  const state = store.getState()
  const plan = state.plans[state.planId]
  const coreBenefits = plan.coreBenefits
  const urlProfile =
    getURLProfile({
      salesCenterAgent,
      placement,
      agentId: agentInformation.agent_id,
      addQuoteKey: true
    }) + `&uid=${state.hcStorage.healthcareUserId}`

  data.template_name = 'singular'
  data.message.global_merge_vars = data.message.global_merge_vars.concat([
    {
      name: 'plan',
      content: {
        link: `https://${window.location.hostname}${path}?${urlProfile}`,
        cigna: plan.coreBenefits.networkProvider === 'cigna',
        epic: isEpicPlan(plan),
        rx: isRXPlan(plan),
        title: state.planName,
        brochure: state.brochures[plan.brochureId],
        details: [
          {
            key: 'Deductible',
            value: asMoneyWithoutDecimal(+coreBenefits.deductible)
          },
          {
            key: 'Coinsurance',
            value: coreBenefits.userCoinsurance + '%'
          },
          {
            key: 'Max Out of Pocket',
            value: asMoneyWithoutDecimal(+coreBenefits.outOfPocketMax)
          },
          {
            key: 'Total Policy Coverage',
            value: asMoneyWithoutDecimal(+coreBenefits.lifetimeMax)
          }
        ]
      }
    },
    {
      name: 'daysCoverage',
      content: state.periodRange.days
    },
    {
      name: 'prices',
      content: {
        plan:
          plan.productId === BTM
            ? moneyFormat(state.prices.planNumber)
            : state.prices.plan,
        dental: state.prices.dentalVision,
        latitude: state.prices.latitude,
        total: state.prices.total,
        supplemental: state.prices.supplemental,
        fee: state.prices.subscriptionFee
      }
    }
  ])

  if (state.dentalPlanId) {
    const dentalPlan = state.plans[state.dentalPlanId]
    const badgeData = getBadgeDental(
      state.addOnTitle || dentalPlan.planName,
      state.hcStorage.members
    )

    data.message.global_merge_vars.push({
      name: 'dental',
      content: {
        name: state.dentalVisionTitle,
        fees: detailsDentalFees(dentalPlan, state.plans[state.visionPlanId]),
        brochure: state.brochures[dentalPlan.brochureId],
        badge: badgeData.message,
        details: [
          `<span>Preventive<br />& Diagnostic <b>${dentalPlan.coreBenefits.preventiveDiagnostic}</b></span>`,
          `<span>Basic Services<br /><b>${dentalPlan.coreBenefits.basicServices}</span>`,
          `<span>Major Services<br /><b>${dentalPlan.coreBenefits.majorServices}</b></span>`,
          `<span>Deductible<br /><b>${dentalPlan.coreBenefits.deductible}</b></span>`
        ]
      }
    })
  }

  if (state.latitudeId) {
    const response = getLatitudeBenefits(latitudeJson.membershipBenefits)
    const latitudePlan = state.plans[state.latitudeId]

    data.message.global_merge_vars.push({
      name: 'latitude',
      content: {
        name: latitudePlan.planName,
        brochure: state.brochures[latitudePlan.brochureId],
        message: response.membersBenefits,
        disclaimer: response.disclaimer,
        details: [
          `<span>Accident<br /><b>${asMoneyWithoutDecimal(
            +latitudePlan.coreBenefits.accidentalDeath
          )}</b></span>`,
          `<span>Critical illness<br /><b>${asMoneyWithoutDecimal(
            +latitudePlan.coreBenefits.criticalIllness
          )}</b></span>`,
          `<span>Accidental death<br /><b>${asMoneyWithoutDecimal(
            +latitudePlan.coreBenefits.accidentalDeath
          )}</b></span>`,
          `<span>Hospital benefits<br /><b>${asMoneyWithoutDecimal(
            +latitudePlan.coreBenefits.hospitalBenefits
          )}/day</b></span>`
        ]
      }
    })
  }

  if (state.supplementalId) {
    data.message.global_merge_vars.push({
      name: 'supplemental',
      content: {
        name: 'Accident Rider'
      }
    })
  }

  return data
}

export default makePayload
